import { SET_MODE, SET_BOUNDS, SET_ZOOM, SET_ACTIVE_FEATURE } from '../actions/mapSettings'
import { morph } from '../utils'

export const initialBounds = [-124, 32, -114, 42.5]

const defaultState = {
    bounds: initialBounds,
    zoom: 7,
    mode: 'single',
    activeFeature: null
}

export default (state = defaultState, action) => {
    switch (action.type) {
        case SET_BOUNDS:
            return morph(state, { bounds: action.bounds })

        case SET_ZOOM:
            return morph(state, { zoom: action.zoom })

        case SET_MODE:
            return morph(state, { mode: action.mode })

        case SET_ACTIVE_FEATURE:
            return morph(state, { activeFeature: action.feature })

        default:
            return state
    }
}
